<div class="container-fluid p-3">
    <div
        class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-4 flex-wrap">
        <!-- Title aligned to the right on larger screens -->
        <h4 class="m-0 text-md-end text-start text-color fs-24 fg-500">
            {{ 'ADMIN.USERS' | translate }}
        </h4>
        <!-- Buttons stacked on small screens -->
        <div class="d-flex flex-column flex-sm-row gap-2 flex-wrap">
            <app-button (click)="addUser()" [label]="'ADMIN.ADD_USER' | translate"
                [customClasses]="'fs-14 fg-600 py-2 px-5 btn-create-test'" [type]="'button'" />
        </div>
    </div>
    <!-- Les comptes vivent dans Keycloak : aucun endpoint ne les liste encore. -->
    @if (users.length === 0) {
        <div class="alert alert-info d-flex align-items-start gap-2" role="status">
            <i class="fa-solid fa-circle-info mt-1"></i>
            <span>{{ 'ADMIN.USERS_EMPTY' | translate }}</span>
        </div>
    }
    <app-custom-tab [data]="users" [columns]="userColumns" [actionTemplate]="userActionsTemplate"
        [locale]="currentLocale" [enableRtl]="isRTL" (rowClick)="handleRowClick($event)" (edit)="onEditUser($event)"
        (delete)="onDeleteUser($event)" (show)="onShowUser($event)">
        <!-- Define the actions template here -->
        <ng-template #userActionsTemplate let-data>
            <button class="btn btn-sm btn-primary mx-1" (click)="onEditUser(data)">
                <i class="fa-solid fa-pen-to-square"></i>
            </button>
            <button class="btn btn-sm btn-danger mx-1" (click)="onDeleteUser(data)">
                <i class="fa-solid fa-trash-can"></i>
            </button>
            <button class="btn btn-sm btn-secondary mx-1" (click)="onShowUser(data)">
                <i class="fa-solid fa-eye"></i>
            </button>
        </ng-template>
    </app-custom-tab>
</div>